<template>
  <page-tab
    :banner="banner"
    :breadcrumb="breadcrumb"
    :tabList="tabList"
    listKey="code"
    v-model="tabCurrent"
    @change="tabChange"
  >
    <div class="news-detail">
      <div class="detail-warpper">
        <div class="title">{{ detail.title }}</div>
        <div class="time">
          {{ detail.updateTime && detail.updateTime.split(" ")[0] }}
        </div>
        <div class="detailHtml" v-html="detail.content"></div>
      </div>
      <div class="news-list" v-if="!isMobile">
        <div class="list-title">推荐新闻</div>
        <div
          class="item"
          v-for="(item, i) in list"
          :key="i"
          @click="toDetail(item.id)"
        >
          <div class="item-content">
            <div class="name">{{ item.title }}</div>
            <div class="time">
              {{ item.updateTime && item.updateTime.split(" ")[0] }}
            </div>
            <p>{{ item.summary }}</p>
          </div>
        </div>
      </div>
    </div>
  </page-tab>
</template>
<script>
import PageTab from "@/components/PageTab.vue";
import banner from "@/assets/images/banner/news.png";
import { pageByCode, newsDetail } from "@/api/index";

export default {
  name: "NewsDetail",
  components: {
    PageTab,
  },
  data() {
    return {
      banner,
      breadcrumb: [
        { name: "首页", path: "/" },
        { name: "企业动态", path: "" },
        { name: "新闻资讯", path: "" },
      ],
      tabList: [
        { name: "新闻资讯", code: "c_news" },
        { name: "行业新闻", code: "c_notice" },
      ],
      tabCurrent: "",
      list: [],
      queryParams: {
        pageNum: 1,
        pageSize: 4,
      },
      total: 0,
      detail: {},
      id: "",
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        if (!val.query.id) return;
        this.id = val.query.id;
        this.getData();
      },
    },
    tabCurrent(val) {
      this.queryParams.pageNum = 1;
      this.getList();
    },
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  methods: {
    tabChange(item) {
      this.breadcrumb[2].name = item.name;
    },
    getList() {
      const params = {
        ...this.queryParams,
        code: this.tabCurrent,
      };
      pageByCode(params).then((res) => {
        this.list = res.data && res.data.records;
        this.total = res.data && res.data.total;
      });
    },
    getData() {
      newsDetail(this.id).then((res) => {
        this.detail = res.data;
        this.tabCurrent = this.detail.code;
      });
    },
    toDetail(id) {
      if (id == this.$route.query.id) return;
      this.$router.push(`/newsDetail?id=${id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.news-detail {
  display: flex;
  .detail-warpper {
    flex: 1;
    .title {
      padding: 0 20px;
      font-size: 30px;
      color: #000000;
      line-height: 36px;
      text-align: center;
    }
    .time {
      font-size: 14px;
      color: #333;
      line-height: 36px;
      text-align: center;
    }
    .detailHtml {
      margin-top: 25px;
      img {
        max-width: 100%;
      }
    }
  }
}
.news-list {
  width: 250px;
  margin-left: 90px;
  .list-title {
    font-size: 22px;
    color: #000000;
    line-height: 24px;
    padding: 13px 15px;
  }
  .item {
    background: #ffffff;
    border-top: 1px solid #e9e9e9;
    .item-content {
      padding: 28px 15px;
      font-size: 14px;
      color: #333333;
      line-height: 1;
      cursor: pointer;
      &:hover {
        .name {
          text-decoration: underline;
          color: $main-color;
        }
      }
      .name {
        font-size: 18px;
        @include clamp(1);
      }
      .time {
        margin-top: 20px;
      }
      p {
        line-height: 1.7;
        margin-top: 20px;
        @include clamp(3);
      }
    }
  }
}
</style>
